export type IHandleQuickSaveButtonClick = (e: JQuery.ClickEvent) => void;

export function handleQuickSaveButtonClick(e: JQuery.ClickEvent): void {
  const $button = $(e.currentTarget);
  if ($button.hasClass('success')) {
    return;
  }
  const $icon = $button.find('.icon');
  const $form = $button.closest('form') as JQuery<HTMLFormElement>;

  // Messages
  const messages = {} as { successMsg?: string; errorMsg?: string };
  if ($button.data('success-msg')) {
    messages.successMsg = $button.data('success-msg');
  }
  if ($button.data('error-msg')) {
    messages.errorMsg = $button.data('error-msg');
  }

  window.DexeroCoreApp.publish('/sessionUser/restart/');

  $button.addClass('success');
  $icon.removeClass('fa-save fa-check').addClass('fa-check');

  function toggleButtonIcon() {
    setTimeout(() => {
      $button.removeClass('success');
      $icon.removeClass('fa-save fa-check').addClass('fa-save');
    }, 2000);
  }
  window.DexeroCoreApp._saveFormViaAjax($form, false, true, false, false, messages).then(
    toggleButtonIcon
  );
}
